// extracted by mini-css-extract-plugin
export default {"menu_container":"MenuTabs_menu_container__ce+f3","menu":"MenuTabs_menu__1lmn9"};